/**
 * Constantes para validaciones SEO
 * Define límites estándar para campos SEO
 */

export const SEO_VALIDATION_LIMITS = {
  // Límites de caracteres para títulos SEO
  TITLE: {
    MAX_LENGTH: 60
  },

  // Límites para descripciones cortas SEO (meta descriptions)
  SHORT_DESCRIPTION: {
    MIN_LENGTH: 120,
    MAX_LENGTH: 160,
    MIN_WORDS: 20,
    MAX_WORDS: 25
  },

  // Límites para descripciones largas SEO
  LONG_DESCRIPTION: {
    MIN_WORDS: 49,
    MAX_WORDS: 300,
    MIN_LENGTH: 200,
    MAX_LENGTH: 2000
  },

  // Límites para palabras clave
  KEYWORDS: {
    MIN_COUNT: 1,
    MAX_COUNT: 10,
    MIN_LENGTH: 2,
    MAX_LENGTH: 50
  }
} as const;

export const SEO_VALIDATION_MESSAGES = {
  TITLE: {
    TOO_LONG: "El título SEO debe tener máximo 60 caracteres"
  },

  SHORT_DESCRIPTION: {
    TOO_SHORT: "La descripción corta SEO debe tener al menos 120 caracteres",
    TOO_LONG: "La descripción corta SEO debe tener máximo 160 caracteres",
    TOO_FEW_WORDS: "La descripción corta SEO debe tener al menos 20 palabras",
    TOO_MANY_WORDS: "La descripción corta SEO debe tener máximo 25 palabras"
  },

  LONG_DESCRIPTION: {
    TOO_FEW_WORDS: "La descripción SEO debe tener al menos 49 palabras",
    TOO_MANY_WORDS: "La descripción SEO debe tener máximo 300 palabras",
    TOO_SHORT: "La descripción SEO debe tener al menos 200 caracteres",
    TOO_LONG: "La descripción SEO debe tener máximo 2000 caracteres"
  },

  KEYWORDS: {
    TOO_FEW: "Debe agregar al menos una palabra clave",
    TOO_MANY: "No puede agregar más de 10 palabras clave",
    TOO_SHORT: "Las palabras clave deben tener al menos 2 caracteres",
    TOO_LONG: "Las palabras clave deben tener máximo 50 caracteres"
  }
} as const;
